import { memo, useState } from 'react';

import { useTranslate } from 'hooks';

import { Settings2FAAuthentication } from './Settings2FAAuthentication';
import { SettingsCard } from './SettingsCard';
import { SettingsPasswordModal } from './SettingsPasswordModal';

import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-select.svg';

import styles from './index.module.scss';
import {SettingsActiveSessionsModal} from "./SettingsActiveSessionsModal";

export const SettingsSecurityCard = memo(() => {
	const [isOpenChangePassword, setIsOpenChangePassword] = useState(false);
	const [isOpenActiveSessions, setIsOpenActiveSessions] = useState(false);
	const { changePasswordText, securityText, activeSessions } = useTranslate(['changePasswordText', 'securityText', 'activeSessions']);
	return (
		<SettingsCard title={securityText} className={styles.security}>
			<div
				role="button"
				className={styles.rowSelect}
				onClick={() => setIsOpenChangePassword((prev) => !prev)}
			>
				{changePasswordText} <ArrowLeft />
			</div>
			<div className={styles.rowSelect}>
				<Settings2FAAuthentication />
			</div>
			<div
				role="button"
				className={styles.rowSelect}
				onClick={() => setIsOpenActiveSessions((prev) => !prev)}
			>
				{activeSessions} <ArrowLeft />
			</div>
			{isOpenChangePassword && (
				<SettingsPasswordModal
					isOpen={isOpenChangePassword}
					onClose={() => setIsOpenChangePassword(false)}
				/>
			)}
			{isOpenActiveSessions && (
				<SettingsActiveSessionsModal
					isOpen={isOpenActiveSessions}
					onClose={() => setIsOpenActiveSessions(false)}
				/>
			)}
		</SettingsCard>
	);
});
